export default "__VITE_ASSET__CEFvDyuw__"